import React, { useState } from "react";
import { logo } from "../../assets/images";
import { useTranslation } from "react-i18next";
import { FiMenu, FiX } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";
import LanguageSwitcher from "../../LanguageSwitcher";


const Header = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isActiveLink = (path) => location.pathname.startsWith(path);

  return (
    <>
      <div className="bg-white">
        <div className="h-[80px] flex justify-between text-[#1C1C1C] max-w-containerSm md:max-w-container mx-auto">
          <div className="flex items-center">
            <a className="mx-auto" href={`/${currentLanguage}`}>
              <img className="mx-auto w-[204px]" alt="logo" src={logo}></img>
            </a>
          </div>
          <div className="flex justify-center items-center ">
            <nav className="hidden md:block">
              <ul className="flex items-center relative">
                <li className="relative group">
                  <a
                    href={`/${currentLanguage}`}
                    className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200"
                  >
                    {t("Ana səhifə")}
                  </a>
                </li>

                {/* <li className="relative group">
                  <a
    className="py-7 px-3 font-medium flex items-center gap-1
    group-hover:text-firstColor transition-colors duration-200 cursor-pointer"
  >
    {t("Haqqımızda")}
    <FiChevronDown
      className="text-sm transition-transform duration-200 group-hover:rotate-180"
    />
  </a>

                  <ul
                    className="absolute left-0 top-full min-w-[180px]
               bg-white shadow-lg opacity-0 invisible
               group-hover:opacity-100 group-hover:visible
               transition-all duration-200 z-50"
                  >
                    <li>
                      <a
                        href={`/${currentLanguage}/about`}
                        className="block px-4 py-3 hover:bg-gray-100 hover:text-firstColor font-medium"
                      >
                        {t("Tarixçəmiz və Hədəfimiz")}
                      </a>
                    </li>

                    <li>
                      <a 
                        href={`/${currentLanguage}/about/leader`}
                        className="block px-4 py-3 hover:bg-gray-100 hover:text-firstColor font-medium"
                      >
                        {t("Şirkətimizin Qurucusu")}
                      </a>
                    </li> 
                  </ul>
                </li> */}

                  <li className="relative group">
                  <a
                    href={`/${currentLanguage}/about`}
                    className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200"
                  >
                    {t("Haqqımızda")}
                  </a>
                </li>

                <li className="relative group">
                  <a
                    href={`/${currentLanguage}/services`}
                    className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200"
                  >
                    {t("Xidmətlər")}
                  </a>
                </li>

                <li className="relative group">
                  <a
                    href={`/${currentLanguage}/projects`}
                    className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200"
                  >
                    {t("Layihələr")}
                  </a>
                </li>

                <li className="relative group">
                  <a
                    href={`/${currentLanguage}/blogs`}
                    className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200"
                  >
                    {t("Bloq")}
                  </a>
                </li>

  <li className="relative group">
                  <a
                    href={`/${currentLanguage}/media`}
                    className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200"
                  >
                    {t("Media")}
                  </a>
                </li>
                <li className="relative group">
                  <a
                    href={`/${currentLanguage}/contact`}
                    className="py-7 px-3 font-medium group-hover:text-firstColor group-hover:bg-[white] transition-colors duration-200"
                  >
                    {t("Əlaqə")}
                  </a>
                </li>
                 <li className="relative group">
                 <LanguageSwitcher/>
                </li>
                {/* <LanguageSwitcher /> */}
              </ul>
            </nav>
            {/* <div className="mr-4 md:hidden">
            <LanguageSwitcher />
          </div> */}
            <button
              className="lg:hidden text-gray-700 mt-4"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? (
                <FiX size={28} color="#000" />
              ) : (
                <FiMenu color="#000" size={24} />
              )}
            </button>
            <div></div>
            {isMobileMenuOpen && (
              <div
                className={`fixed inset-0 bg-white text-black z-50 transform ${
                  isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
                } transition-transform duration-300 ease-in-out`}
              >
                <div className="max-w-containerSm mx-auto pt-8 flex flex-col h-full">
                  {/* Kapatma Butonu */}
                  <div className="flex justify-between">
                    <img className="h-[59px]" src={logo}></img>
                    <button onClick={() => setIsMobileMenuOpen(false)}>
                      <FiX size={32} />
                    </button>
                  </div>

                  {/* Menü İçeriği */}
                  <nav className="mt-10">
                    {[
                      { path: "/", label: "Ana səhifə" },
                      { path: "/about", label: "Haqqımızda" },
                      { path: "/services", label: "Xidmətlər" },
                      { path: "/projects", label: "Layihələr" },
                      { path: "/partners", label: "Tərəfdaşlıq" },
                      { path: "/blogs", label: "Bloqlar" },
                       { path: "/media", label: "Media" },
                      { path: "/contact", label: "Əlaqə" },
                    ].map((item, index) => (
                      <a
                        key={index}
                        href={`/${currentLanguage}${item.path}`}
                        className={`block text-lg py-3 rounded-lg transition ${
                          isActiveLink(item.path)
                            ? "text-firstColor font-medium"
                            : "text-black"
                        }`}
                      >
                        {t(item.label)}
                      </a>
                    ))}
                    <LanguageSwitcher/>
                  </nav>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
